import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { ModalHeader, ModalContent } from 'app/components/shared/Modal';
import Heading from 'app/components/shared/Heading';
import Divider from 'app/components/bibs/shared/Divider';
import { Link } from '@bibliocommons/base-links';

import './OtherLanguagesModal.scss';

export default function OtherLanguagesModal({ otherLanguageTitles }) {
  function renderTitle(title) {
    return (
      <div className="other-languages-title">
        <Divider />
        <Link className="other-languages-title-link" dataKey={title.get('id')} href={`/v2/record/${title.get('id')}`}>
          <>
            <Heading tagName="div" size="modest" variant className="title-info">
              {title.getIn(['brief', 'otherScriptTitle']) || title.getIn(['brief', 'title'])}
            </Heading>
            <div className="language-info">
              <FormattedMessage id={`LANGUAGE.${title.getIn(['brief', 'primaryLanguage'])}`} />
            </div>
          </>
        </Link>
      </div>
    );
  }

  return (
    <div className="cp-other-languages-modal">
      <ModalHeader title={<FormattedMessage id="other_languages" />} />
      <ModalContent>{otherLanguageTitles.map(title => renderTitle(title))}</ModalContent>
    </div>
  );
}

OtherLanguagesModal.propTypes = {
  otherLanguageTitles: ImmutablePropTypes.list.isRequired
};
